import React from 'react'
import { Form, Input, Select } from 'antd'
import AceEditor from 'react-ace'
import CompileTemplateIcon from '../../../../../../reusables/components/compile-template-icon'
import MemoryStore from '../../../../../../utils/memory-store'

import 'brace/mode/json'
import 'brace/mode/sql'
import 'brace/theme/xcode'

// Custom Components
import OracleHelp from '../../../../../../reusables/components/oracle-help'

class OracleDbRouteExecute extends React.Component {
  constructor (props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.state = {
      entry: props.entry.routeData,
      getQuery: props.entry.routeData.getQuery || '0'
    }

    // Bindings
    this.changeGetQry = this.changeGetQry.bind(this)
    this.onFieldChange = this.onFieldChange.bind(this)
  }

  UNSAFE_componentWillMount () {
    if (!this.props.entry.routeData.getQuery) {
      this.props.entry.routeData.getQuery = '0'
    }
  }

  changeGetQry (e) {
    this.entry.custom.isModifiedSubform = true
    this.setState({ getQuery: e })
  }

  onFieldChange (key, value) {
    this.entry.custom.isModifiedSubform = true
    this.props.entry.routeData[key] = value.trim()
  }

  render () {
    return (
      <div>
        <Form.Item>
          Get Query Statement
          <Select
            className='get_query'
            disabled={this.props.disabled}
            defaultValue={this.state.getQuery}
            onChange={e => {
              this.onFieldChange('getQuery', e)
              this.changeGetQry(e)
            }}
          >
            <Select.Option value='0'>Here</Select.Option>
            <Select.Option value='1'>From Template Profile</Select.Option>
          </Select>
        </Form.Item>
        {this.state.getQuery === '0' ?
          <Form.Item>
            {'SQL Qry Body '}
            <CompileTemplateIcon />
            <AceEditor
              readOnly={this.props.disabled}
              showPrintMargin={false}
              cursorStart={1}
              mode='sql'
              theme='xcode'
              style={{ width: '100%', height: 300 }}
              name='aceEditor'
              value={this.state.entry.data}
              setOptions={{
                showLineNumbers: true,
                newLineMode: 'unix'
              }}
              onChange={e => {
                this.onFieldChange('data', e)
              }}
            />
          </Form.Item>
          :
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>
            {'Template Profile Key '}
            <CompileTemplateIcon />
            <Input
              name='template_key'
              placeholder='Template Key'
              disabled={this.props.disabled}
              defaultValue={this.state.entry.templateKey}
              onChange={e => {
                this.onFieldChange('templateKey', e.target.value)
              }}
            />
          </Form.Item>
        }
        <Form.Item>
          <div>
            Bind Parameters <CompileTemplateIcon /> <OracleHelp field='Bind Parameters' />
            <AceEditor
              showPrintMargin={false}
              readOnly={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              cursorStart={1}
              mode='json'
              theme='xcode'
              style={{ width: '100%', height: 200 }}
              name='aceEditor'
              value={this.state.entry.bindParameters}
              setOptions={{
                showLineNumbers: true,
                newLineMode: 'unix'
              }}
              onChange={value => {
                this.onFieldChange('bindParameters', value)
              }}
            />
          </div>
        </Form.Item>
        <Form.Item>
          <div>
            Options <CompileTemplateIcon /> <OracleHelp field='Options' />
            <AceEditor
              showPrintMargin={false}
              readOnly={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              cursorStart={1}
              mode='json'
              theme='xcode'
              style={{ width: '100%', height: 200 }}
              name='aceEditor'
              value={this.state.entry.options}
              setOptions={{
                showLineNumbers: true,
                newLineMode: 'unix'
              }}
              onChange={value => {
                this.onFieldChange('options', value)
              }}
            />
          </div>
        </Form.Item>
      </div>
    )
  }
}

export default OracleDbRouteExecute
